import React from "react";
import { useParams } from "react-router-dom";
import StudentMonthlyReport from "../components/Reports/StudentMonthlyReport";

const StudentMonthlyReportPage = () => {
  const { studentId } = useParams();

  const now = new Date();

  const year = now.getFullYear();
  const month = now.getMonth() + 1;

  return (
    <StudentMonthlyReport studentId={studentId} year={year} month={month} />
  );
};

export default StudentMonthlyReportPage;
